




export function getWeatherIcon(type, startTime) {
  
  const isDaytime = startTime === "day";

    switch (type) {
    case 'CLEAR':
        return isDaytime ? '/animated/clear-day.svg' : '/animated/clear-night.svg';

    case 'MOSTLY_CLEAR':
      
       return isDaytime ? '/animated/cloudy-1-day.svg' : '/animated/cloudy-1-night.svg';


    case 'PARTLY_CLOUDY':
         return isDaytime ? '/animated/cloudy-2-day.svg' : '/animated/cloudy-2-night.svg';

    case 'MOSTLY_CLOUDY':
   
      return isDaytime ? '/animated/cloudy-3-day.svg' : '/animated/cloudy-3-night.svg';

    case 'OVERCAST':
         case 'CLOUDY':
      return '/animated/cloudy.svg';

    case 'FOG':
      return isDaytime ? '/animated/fog-day.svg' : '/animated/fog-night.svg';
    case 'HAZE':
      return isDaytime ? '/animated/haze-day.svg' : '/animated/haze-night.svg';
    case 'SMOKE':
      return '/animated/haze.svg';

    case 'WINDY':
    case 'BREEZY':
      return '/animated/wind.svg';

    case 'WIND_AND_RAIN':
      return '/animated/rainy-3.svg';

    case 'LIGHT_RAIN_SHOWERS':
    case 'CHANCE_OF_SHOWERS':
    case 'SCATTERED_SHOWERS':
    case 'RAIN_SHOWERS':
      return isDaytime ? '/animated/rainy-1-day.svg' : '/animated/rainy-1-night.svg';

    case 'HEAVY_RAIN_SHOWERS':
    case 'LIGHT_TO_MODERATE_RAIN':
    case 'MODERATE_TO_HEAVY_RAIN':
    case 'RAIN':
    case 'LIGHT_RAIN':
    case 'HEAVY_RAIN':
    case 'RAIN_PERIODICALLY_HEAVY':
      return isDaytime ? '/animated/rainy-2-day.svg' : '/animated/rainy-2-night.svg';

    case 'LIGHT_SNOW_SHOWERS':
    case 'CHANCE_OF_SNOW_SHOWERS':
    case 'SCATTERED_SNOW_SHOWERS':
    case 'SNOW_SHOWERS':
      return isDaytime ? '/animated/snowy-1-day.svg' : '/animated/snowy-1-night.svg';

    case 'HEAVY_SNOW_SHOWERS':
    case 'LIGHT_TO_MODERATE_SNOW':
    case 'MODERATE_TO_HEAVY_SNOW':
    case 'SNOW':
    case 'LIGHT_SNOW':
    case 'HEAVY_SNOW':
    case 'SNOW_PERIODICALLY_HEAVY':
      return isDaytime ? '/animated/snowy-2-day.svg' : '/animated/snowy-2-night.svg';

    case 'SNOWSTORM':
    case 'HEAVY_SNOW_STORM':
    case 'BLOWING_SNOW':
      return isDaytime ? '/animated/snowy-3-day.svg' : '/animated/snowy-3-night.svg';

    case 'RAIN_AND_SNOW':
      return '/animated/rain-and-snow-mix.svg';

    case 'SNOW_AND_SLEET_MIX':
      return '/animated/snow-and-sleet-mix.svg';
    case 'RAIN_AND_SLEET_MIX':
      return '/animated/rain-and-sleet-mix.svg';

    case 'HAIL':
    case 'HAIL_SHOWERS':
      return '/animated/hail.svg';

    case 'THUNDERSTORM':
    case 'THUNDERSHOWER':
    case 'LIGHT_THUNDERSTORM_RAIN':
      return isDaytime ? '/animated/isolated-thunderstorms-day.svg' : '/animated/isolated-thunderstorms-night.svg';

    case 'SCATTERED_THUNDERSTORMS':
      return isDaytime ? '/animated/scattered-thunderstorms-day.svg' : '/animated/scattered-thunderstorms-night.svg';

    case 'HEAVY_THUNDERSTORM':
      return '/animated/severe-thunderstorm.svg';

    case 'TORNADO':
      return '/animated/tornado.svg';
    case 'HURRICANE':
      return '/animated/hurricane.svg';
    case 'TROPICAL_STORM':
      return '/animated/tropical-storm.svg';

    case 'HOT':
      return '/animated/clear-day.svg';
    case 'COLD':
      return '/animated/snowy-1.svg';

    case 'TYPE_UNSPECIFIED':
    default:
      return isDaytime ? '/animated/cloudy-1-day.svg' : '/animated/cloudy-1-night.svg';

  }
}

/*









TYPE_UNSPECIFIED	
CLEAR	
MOSTLY_CLEAR	
PARTLY_CLOUDY	
MOSTLY_CLOUDY	
CLOUDY	
WINDY	
WIND_AND_RAIN	
LIGHT_RAIN_SHOWERS	
CHANCE_OF_SHOWERS	
SCATTERED_SHOWERS	
RAIN_SHOWERS	
HEAVY_RAIN_SHOWERS	
LIGHT_TO_MODERATE_RAIN	
MODERATE_TO_HEAVY_RAIN	
RAIN	
LIGHT_RAIN	
HEAVY_RAIN	
RAIN_PERIODICALLY_HEAVY	
LIGHT_SNOW_SHOWERS	
CHANCE_OF_SNOW_SHOWERS	
SCATTERED_SNOW_SHOWERS
SNOW_SHOWERS	
HEAVY_SNOW_SHOWERS	
LIGHT_TO_MODERATE_SNOW	
MODERATE_TO_HEAVY_SNOW	
SNOW	
LIGHT_SNOW	
HEAVY_SNOW	
SNOWSTORM	
SNOW_PERIODICALLY_HEAVY	
HEAVY_SNOW_STORM	
BLOWING_SNOW	
RAIN_AND_SNOW	
HAIL
HAIL_SHOWERS	
THUNDERSTORM	
THUNDERSHOWER	
LIGHT_THUNDERSTORM_RAIN	
SCATTERED_THUNDERSTORMS	
HEAVY_THUNDERSTORM	



*/